import { useStorage } from '@funtech-int/web-toolkit';
import { useCallback, useEffect, useMemo } from 'react';

const REFRESHES_TILL_SUPPORT = 2;
const ERROR_REFRESHES_KEY = 'ERROR_REFRESHES';

export const useRefreshCount = (maxRefresh: number = REFRESHES_TILL_SUPPORT) => {
    const storage = useStorage();

    const refreshed = useMemo(
        () => Number(storage.session.get(ERROR_REFRESHES_KEY) ?? 0),
        [storage]
    );

    useEffect(() => {
        storage.session.set(ERROR_REFRESHES_KEY, String(refreshed + 1));
    }, [refreshed, storage]);

    const refresh = useCallback(() => {
        window.location.reload();
    }, []);

    return {
        isSupportShown: refreshed >= maxRefresh,
        refresh,
    };
};
